import GenericModal from 'components/GenericModal/GenericModal';
import React from 'react';
import { ContentUtil } from 'utils/content';

import { content } from './espn-proposal.content';

const contentUtil = new ContentUtil({ content, componentName: 'ESPNProposal' });

const ESPNProposalEscapeModal = ({ onClose }: { onClose: () => void }) => {
  return (
    <GenericModal title={contentUtil.translateToString('escape.modal.title')} onClose={onClose}>
      <p>{contentUtil.translateHtml('escape.modal.content')}</p>
    </GenericModal>
  );
};

export default ESPNProposalEscapeModal;
